import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 环境监测器设备列表
  mobileenvdevicelist(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/env/device/list',
      method: 'get',
      params: args
    })
  },
  // 环境信息列表
  mobileenvitemlist(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/env/item/list',
      method: 'get',
      params: args
    })
  },
  // 环境监测指标查看
  envrulegetEnvRule(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/env/rule/getEnvRule',
      method: 'get',
      params: args
    })
  },
  // 环境信息列表
  kanBanEnvAlertMsg(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/env/alert/page',
      method: 'get',
      params: {
        pageNum: 1,
        pageSize: 10,
        ...args
      }
    })
  },
  kanBanDeviceNewAlertMsg(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/deviceAlert/new',
      method: 'post',
      data: args
    })
  },
  kanBanHeightNewAlertMsg(projectId) {
    return Axios({
      url: requestPrefix.projectUrl + `/deviceHighFormwork/countRecord/${projectId}`,
      method: 'get'
    })
  },
  kanBanPitNewAlertMsg(args) {
    return Axios({
      url: requestPrefix.projectUrl + `/pitRecord/getAlarmCountByDays`,
      method: 'post',
      data: args
    })
  },
  kanBanGetAll(args) {
    return Axios({
      url: requestPrefix.projectUrl + `/deviceAlert/all`,
      method: 'post',
      data: args
    })
  },
  // 喷淋开关开启，10分钟自动关闭
  sprayTurnOn(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/env/devices/sprayTurnOn',
      method: 'get',
      params: args
    })
  },
   // 国控点
 getDaYunDustNoise(id) {
    return Axios({
      url: requestPrefix.projectUrl + '/env/dustData/getDaYunDustNoise?projectId=' + id,
      method: 'get'
    })
  },
  infogetlist(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/env/item/page',
      method: 'get',
      params: data
    })
  },

}



// WEBPACK FOOTER //
// ./src/api/environmentmanage/index.js